import { render, staticRenderFns } from "./gamedetail.vue?vue&type=template&id=7a08ce6c&scoped=true&"
import script from "./gamedetail.vue?vue&type=script&lang=js&"
export * from "./gamedetail.vue?vue&type=script&lang=js&"
import style0 from "./gamedetail.vue?vue&type=style&index=0&id=7a08ce6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08ce6c",
  null
  
)

export default component.exports